import { render, staticRenderFns } from "./SocialShareGeneric.vue?vue&type=template&id=346762fd&scoped=true&"
import script from "./SocialShareGeneric.vue?vue&type=script&lang=js&"
export * from "./SocialShareGeneric.vue?vue&type=script&lang=js&"
import style0 from "./SocialShareGeneric.vue?vue&type=style&index=0&id=346762fd&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346762fd",
  null
  
)

export default component.exports